import React, { createContext, useContext, useState, useCallback } from 'react';
import { FaqDialog } from './FaqDialog';

interface FaqDialogContextValue {
  openFaqDialog: () => void;
}

const FaqDialogContext = createContext<FaqDialogContextValue | undefined>(undefined);
export { FaqDialogContext };

export const FaqDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openFaqDialog = useCallback(() => setOpen(true), []);
  const closeFaqDialog = useCallback(() => setOpen(false), []);

  return (
    <FaqDialogContext.Provider value={{ openFaqDialog }}>
      {children}
      <FaqDialog open={open} onClose={closeFaqDialog} />
    </FaqDialogContext.Provider>
  );
};

export function useGlobalFaqDialog(): () => void {
  const ctx = useContext(FaqDialogContext);
  if (!ctx) throw new Error('useGlobalFaqDialog must be used within a FaqDialogProvider');
  return ctx.openFaqDialog;
}
